import { Box } from "@mui/material";

interface NavigationMenuItemsWrapperDesktopProps {
  children: React.ReactNode;
}

export function NavigationMenuItemsWrapperDesktop(props: NavigationMenuItemsWrapperDesktopProps) {
  const { children } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        paddingY: 2,
        paddingX: 4,
        overflowY: "auto",
      }}
    >
      {children}
    </Box>
  );
}
